<div class="flight-details__wrapper">
	<div class="flight-details__main">
		<div class="flight-details__logo" [tooltip]="INDRA_printAirlineName()" 
			attr.aria-label="{{(INDRA_returnAriaLabelTranslation() | ibeadmin | async) + INDRA_printAirlineName()}}">
			<app-svg [svg]="INDRA_printAirlineLogo()" [alt]="INDRA_printAirlineName()" [classes]="'logo'"></app-svg>
		</div>
		<div class="flight-details__route" [attr.aria-label]="INDRA_ariaLabelRoute()">
			<div class="flight-details__time-location is-departure" 
				tooltip="{{ INDRA_getDepartureLocation().city }}"
				[attr.aria-label]="INDRA_returnAriaLabelFlightRouteDescription()">
				{{ INDRA_getDepartureLocation().code }}
			</div>
			<div class="flight-details__arrow">
				<app-arrow [legs]="INDRA_printLegStops()" [stops]="INDRA_getStops()"></app-arrow>
			</div>
			<div class="flight-details__time-location is-arrival" 
				tooltip="{{ INDRA_getArrivalLocation().city }}"
				[attr.aria-label]="INDRA_returnAriaLabelFlightRouteDescription()">
				{{ INDRA_getArrivalLocation().code }}
			</div>
		</div>
		<p class="muted" *ngIf="isMYB || isReviewFlights || isTimeToThinkFlights">
			<a class="link" (click)="INDRA_handleDetailsClick()" href="javascript:;" role="button">
				{{ 'bookingDetails.link.flightdetails' | ibeadmin | async }}
			</a>
		</p>
	</div>
	<div class="flight-details__whitespace"></div>
	<div class="flight-details__brand">
		<app-svg class="img-brand hidden-mobile brand--{{INDRA_getBrandClass()}}"
			[attr.aria-label]="'Flight with ' + INDRA_printBrand() + ' fare'" svg="sprite.svg#brand--{{ INDRA_printBrandLogo() }}"
			[alt]="INDRA_printBrand() + ' fare logo'" >
		</app-svg>
		<app-svg class="img-brand hidden-tablet-portrait-up"
			[attr.aria-label]="'Flight with ' + INDRA_printBrand() + ' fare'"
			svg="sprite.svg#brand--{{ INDRA_printBrandLogo() }}_icon" 
			[alt]="INDRA_printBrand() + ' fare logo'">
		</app-svg>
	</div>
</div>
